import styled from 'styled-components';

interface SpinnerProps {
    size: string;
}

const Spinner = styled.div<SpinnerProps>`
    ${({ theme: { colors }, size }) => `
        border: 2px solid ${colors.brand.main};
        border-top: 2px solid ${colors.background.overlay.v5};
        width: ${size}px;
        height: ${size}px;
    `}
    border-radius: 50%;
    -webkit-animation: spin 1s linear infinite; /* Safari */
    animation: spin 1s linear infinite;
`;

export { Spinner };
